import {Controller, useFormContext} from "react-hook-form";
import {ZyusetuFieldKeyFragmentFragment, ZyusetuFieldKeyType,} from "@/graphql/graphql";
import {FormSchema} from "@/components/pages/Zyusetu/ZyusetuEditorSection.tsx";
import {TextField} from "@mui/material";
import {zyusetuValueIntoZodValue} from "@/hooks/useGetFirstContent";

interface ZyusetuStringFieldProps {
  fieldKey: ZyusetuFieldKeyFragmentFragment;
  onFocus: () => void;
  updateField: (
    keyId: string,
    keyName: string,
    value: FormSchema<ZyusetuFieldKeyType.String>[string],
  ) => Promise<void>;
  isAvailable: boolean;
}

export function ZyusetuStringField({
                                     fieldKey,
                                     onFocus,
                                     updateField,
                                     isAvailable,
                                   }: ZyusetuStringFieldProps) {
  const {control} = useFormContext<FormSchema<ZyusetuFieldKeyType.String>>();
  return (
    <Controller
      name={fieldKey.keyName}
      control={control}
      render={({field, formState: {errors}, fieldState: {isDirty}}) => (
        <TextField
          {...field}
          disabled={!isAvailable}
          inputRef={field.ref}
          onFocus={onFocus}
          multiline
          minRows={fieldKey.keyStyle.lines ?? undefined}
          value={field.value.value ?? ""}
          onChange={(e) => {
            field.onChange(
              zyusetuValueIntoZodValue(fieldKey, e.target.value ?? ""),
            );
          }}
          onBlur={async () => {
            if (errors?.[fieldKey.keyName]?.value?.message) return;
            if (!isDirty) return;
            
            await updateField(fieldKey.id, fieldKey.keyName, field.value);
          }}
          fullWidth
          error={!!errors?.[fieldKey.keyName]?.value?.message}
          helperText={errors?.[fieldKey.keyName]?.value?.message as string}
          size={"small"}
        />
      )}
    />
  );
}
